import React, { ReactNode, useEffect, useState } from 'react';
import CreatePortal from 'components/portal/CreatePortal';
import { PrintProvider } from './hook/usePrint';
import { styled } from '@mui/material';

const Container = styled('div')({
  backgroundColor: '#fff',
  transition: 'transform 0.2s ease',
  transform: 'translateY(100vh)',
  display: 'flex',
  position: 'fixed',
  inset: 0,
  zIndex: 1300,
  overflow: 'auto',
  justifyContent: 'center',
  textAlign: 'justify',
  padding: '1.5cm',

  '& p': {
    lineHeight: '0.7cm',
    fontSize: 14,
    margin: 0,
  },

  '@media print': {
    position: 'static',
    transform: 'none',
    overflow: 'visible',
    padding: 0,
  },
});

interface PrintProps {
  onExited?(): void;
  children: ReactNode;
}

const Print: React.FC<PrintProps> = ({ children, onExited }) => {
  const [open, setOpen] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (open === undefined) setTimeout(() => setOpen(true), 100);
  }, [open, onExited]);

  function handleClose() {
    setOpen(false);
  }

  return (
    <CreatePortal>
      <PrintProvider value={{ handleClose }}>
        <Container
          onTransitionEnd={!open && !!onExited ? onExited : undefined}
          style={open ? { transform: 'translateY(0)' } : undefined}
        >
          <div className="print">{children}</div>
        </Container>
      </PrintProvider>
    </CreatePortal>
  );
};

export default Print;
